import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import axios from "axios";
import { checkSession } from "modules/login/redux/session.action";
import LoginPage from "modules/login/pages/login.page";
import PortalLayout from "components/layout/PortalLayout";
import NotFound from "modules/not-found/not-found.page";
import SetupPasswordPage from "modules/setup-password/setup-password.page";

axios.defaults.baseURL = process.env.REACT_APP_API_HOST_URL;

const theme = createMuiTheme({
  palette: {
    primary: { main: "#3A4D54" },
    secondary: { main: "#6AAF68" },
    background: { default: "#EBEDEE" },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        backgroundColor: "#3A4D54",
        "&:hover": { backgroundColor: "#2d3b41" },
      },
    },
  },
});

function PrivateRoute({ children, ...rest }) {
  const token = useSelector((state) => state.session.token);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? children : <Redirect to={{ pathname: "/login", state: { from: location } }} />
      }
    />
  );
}

export default function App() {
  const dispatch = useDispatch();
  const isSessionChecked = useSelector((state) => state.session.isSessionChecked);

  useEffect(() => {
    dispatch(checkSession());
  }, [dispatch]);

  if (!isSessionChecked) return null;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/public/setup-password" component={SetupPasswordPage} />
        <PrivateRoute path="/portal">
          <PortalLayout />
        </PrivateRoute>
        <Route path="/404" component={NotFound} />
        <Redirect exact from="/" to="/portal" />
        <Redirect to="/404" />
      </Switch>
    </ThemeProvider>
  );
}
